import { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function ProcessingOverlay({ children, toggleLoading, overLay, isSpinner }) {
  LoadingOverlay.propTypes = undefined // fix the 'failed prop type' warning
  const { t } = useTranslation();
  const [textUpdated, setTextUpdated] = useState(t("Common.processing"));
  let [counter, setCounter] = useState(0);

  const {
    showNewTemplate,
  } = useSelector((state) => ({
    showNewTemplate: state.setApplicationParams.showNewTemplate,
  }));

  useEffect(() => {
    if (!toggleLoading) setCounter(0);
    let loadingInterval = setInterval(() => {
      if (toggleLoading) setCounter((c) => c++);
    }, 1000);
    return () => {
      clearInterval(loadingInterval);
    };
  }, [toggleLoading]);

  useEffect(() => {
    if (counter > 19) {
      setTextUpdated(t("Common.still_processing"));
    } else {
      setTextUpdated(t("Common.processing"));
    }
  }, [counter, t]);

  const SpinnerComponent = isSpinner ? (
    <Spinner
      animation="border"
      variant={showNewTemplate ? "danger" : "light"}
      style={{ 
        width: 50, 
        height: 50, 
        borderWidth: 2,
      }}
    />
  ) : false;

  return (
    <LoadingOverlay
      active={toggleLoading}
      classNamePrefix={overLay ? "" : "_loading_overlay_overlay"}
      spinner={SpinnerComponent}
      styles={{
        overlay: (base) => ({
          ...base,
          background: overLay ? 'rgba(0, 0, 0)' : 'rgba(0, 0, 0, 0.8)',
        }),
        content: (base) => ({
          ...base,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
        })
      }}
      text={textUpdated}
    >
      {children}
    </LoadingOverlay>
  );
}
